module.exports = __webpack_public_path__ + "img/img88.5dab3a7e.svg";